import React from 'react';
import BudgetTracker from '../../components/budget-tracker/BudgetTracker';
import './Budget.css';
import BudgetNav from '../../components/navbar/budget-nav/BudgetNav';

function Budget () {
  return (
    <div className= "budget-page">
     <BudgetNav/> 
    <h1>Budget</h1>
    <p>This is the budget page where you can manage your expenses.</p>

    <BudgetTracker />
    </div>
  );
};

export default Budget;
